export const Globals = {
  IS_PROD_ENV: process.env.NEXT_PUBLIC_IS_PRODUCTION_ENV === "true",
  WAITLIST_ENABLED: true,
  COMPANY: {
    NAME: "Meidly",
    SIREN: "989 292 016",
    SIRET: "989 292 016 00015",
    LEGAL_FORM: "SASU, société par actions simplifiée unipersonnelle",
    TVA: "FR40989292016",
    RCS: "989 292 016 R.C.S. Paris",
    ADDRESS: "14 Rue Lamblardie 75012 Paris",
    EMAIL: "contact@meidly.com",
    PRESIDENT: "Dalil CHABLIS",
  },
  BOOKING_URL: "https://calendly.com/dalilchablis/echange-sur-meidly",
  PROJECTS_PAGINATION_LIMIT: 10,
  USER_PROJECTS_LIMIT: 50,
  CALLS_PER_PAGE: 10,
  CALL_OVERVIEW_MAX_POINTS: 30,
  CALL_OVERVIEW_TOP_ITEMS: 6,
  // Default commission (%): a company affiliation (code = slug) and the value prefilled
  // when an admin creates a personal affiliation.
  COMPANY_AFFILIATION_PERCENTAGE: 10,
  USER_AFFILIATION_PERCENTAGE: 10,
  AFFILIATION_PAYOUT_THRESHOLD_EUR: 100,
  MAX_MERGE_INSIGHTS_PER_TYPE: 30,
  MAX_MERGE_PATTERNS_PER_TYPE: 15,
  MAX_EXPORT_INSIGHTS_PER_TYPE: 30,
  INSIGHTS_DASHBOARD_LIMIT: 3,
  INSIGHTS_PAGINATION_LIMIT: 10,
  MAX_QUOTES_PER_INSIGHT: 5,
  ACTIVE_JOB_POLLING_INTERVAL_MS: 60000,
  AVATAR_JOB_POLLING_INTERVAL_MS: 30000,
  CALL_EXPORT_VERSION: 1,
  MAX_AVATAR_EXTRACTION_INSIGHTS: 150,
  MAX_INSIGHT_CALL_MARKERS: 5,
  MAX_RECOMMENDATION_INSIGHTS_PER_TYPE: 10,
  CALL_TURN_CLASSIFICATION_BATCH_SIZE: 80,
  MAX_DYNAMICS_INSIGHTS: 5,
  MIN_KEY_MOMENTS: 3,
  MAX_KEY_MOMENTS: 10,
  MAX_AVATAR_LIST_ITEMS: 10,
  MAX_SEQUENCE_GENERATED_STEPS: 5,
  MAX_OFFER_LIST_ITEMS: 5,
  MAX_RECOMMENDATION_ACTIONS: 3,
  MAX_AVATAR_TIMELINE_ITEMS: 20,
  MAX_PROSPECT_CRITERIA_ITEMS: 10,
  MAX_PROSPECT_HEADLINE_KEYWORDS: 40,
  PROSPECT_POOL_ENABLED: false,
  LAUNCH_DATE: "2026-11-17T09:00:00+01:00",
  IMPORTED_PROFILE_DETECTION_BATCH_SIZE: 50,
  MAX_AI_DETECTION_QUANTITY: 5000,
  MAX_IMPORTED_PROFILE_REASON: 240,
  PROSPECT_ORDER_MAX_QUANTITY: 100,
  PROSPECT_ORDER_STEP: 10,
  PROSPECT_MIN_FIT_SCORE: 70,
  PROSPECTS_PER_PAGE: 10,
  DASHBOARD_LABEL_MATCH_RATIO: 0.6,
  PROSPECT_ORDERS_PER_PAGE: 6,
  PROSPECT_ACTIONS_PER_PAGE: 8,
  IMPORTED_PROFILES_PER_PAGE: 10,
  INSIGHT_CALLS_PER_PAGE: 6,
  ADMIN_USERS_PER_PAGE: 20,
  AGENT_SEARCHES_PER_PAGE: 8,
  AVATAR_FRESHNESS_STALE_TIME_MS: 60000,
  PROSPECT_FRESHNESS_STALE_TIME_MS: 60000,
  PROSPECT_JOB_POLLING_INTERVAL_MS: 5000,
  MESSAGE_JOB_POLLING_INTERVAL_MS: 5000,
  VARIANT_JOB_POLLING_INTERVAL_MS: 2000,
  FAILED_JOB_LOOKBACK_MS: 86400000,
  FAILED_JOB_NOTIFY_LIMIT: 10,
  FAILED_JOBS_DEFER_MS: 2500,
  SEQUENCE_WRITE_TX_TIMEOUT_MS: 20000,
};
